import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getToken } from "./tokenManager";

let apolloClient;

export const getClient = (cache = {}) => {
  if (apolloClient) return apolloClient;
  const GRAPHQL_URL =
    process.env.REACT_APP_GRAPHQL_URL ||
    "https://api.staging.matchpick.co/graphql";

  const httpLink = createHttpLink({
    uri: GRAPHQL_URL,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      Authorization: `Bearer ${getToken()}`,
    },
  }));

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache().restore(cache),
  });

  apolloClient = client;
  return apolloClient;
};
